/**
 * @generated by @interxfi/j5-codegen (Plugin: NormalizedQueryPlugin) - do not edit */

import type { IxmUserauthV1UserEvent } from '@interxfi/types';
import { schema } from 'normalizr';

export const IXM_USERAUTH_V1_USER_EVENT_ENTITY_NAME = 'ixm.userauth.v1.UserEvent';
export const ixmUserauthV1UserEventEntity = new schema.Entity<IxmUserauthV1UserEvent>(IXM_USERAUTH_V1_USER_EVENT_ENTITY_NAME, {}, { idAttribute: (entity: IxmUserauthV1UserEvent) => `${entity.metadata?.eventId}` });

